module.exports = __webpack_public_path__ + "static/media/arrow-left.4af51529.svg";